
import { defineComponent } from 'vue'
import { useStarTheme } from '@/utils/useStarTheme'

export default defineComponent({
  name: 'StarNoData',
  props: {
    desc: { type: String, default: '暂无数据' }
  },
  setup() {
    const { isLight } = useStarTheme()
    const imgLight = require('@/assets/nodata_light_v.png')
    const imgDark = require('@/assets/nodata_dark_v.png')
    return { isLight, imgLight, imgDark }
  }
})
